// SQLite returns naive datetime strings (no Z / +offset). The ECMAScript spec
// treats bare ISO date-time strings as local time, so we must force UTC by
// appending Z when no timezone designator is present.
function toUTC(isoString: string): Date {
  return /[Z+]/.test(isoString.slice(-6)) ? new Date(isoString) : new Date(isoString + 'Z')
}

export function formatDateTime(isoString: string): string {
  return toUTC(isoString).toLocaleString()
}

// Returns YYYY-MM-DD in the browser's local timezone.
export function localDateString(d: Date = new Date()): string {
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

// Parse a YYYY-MM-DD string as local midnight (not UTC midnight).
export function parseLocalDate(ymd: string): Date {
  return new Date(`${ymd}T00:00:00`)
}

// A todo is overdue when its due date is before today and it isn't finished.
// Both sides are YYYY-MM-DD strings, which compare correctly lexically.
export function isOverdue(dueDate: string | null, status: string | null): boolean {
  if (!dueDate) return false
  if (status === 'done' || status === 'cancelled') return false
  return dueDate < localDateString()
}
